<template>
  <div class="school-page page">
    <BreadcrumbsComponent @back.prevent :links="links" />
    <div class="school-page__content">
      <div
        :class="{
          'school-page__welcome--shift': school.data_items && school.data_items.length,
        }"
        class="school-page__welcome sides-padding"
      >
        <div class="container">
          <h1 class="title">Школа мам Baby Market</h1>
        </div>
      </div>
      <div class="school-page__top-part">
        <AdditionalInfoComponent :list="school.data_items" />
        <div class="container-padding">
          <div class="school-page__welcome-info">
            <h3 class="title">{{ school.title }}</h3>
            <p>
              {{ school.description }}
            </p>
          </div>
        </div>
        <SliderComponent
          class="school-page__speakers container-padding"
          :items="school.speakers || []"
          v-slot="{ item }"
          :slider-options="speakersSliderOptions"
          title="Наши спикеры"
          centerTitle
          sideArrows
        >
          <SpeakerComponent :data="item" />
        </SliderComponent>
        <SliderComponent
          class="school-courses"
          :items="courses"
          v-slot="{ item }"
          :slider-options="coursesSliderOptions"
          title="Курсы школы мам"
          centerTitle
        >
          <CourseComponent :data="item" @claimCreate="claimCreate" />
        </SliderComponent>
      </div>
      <div class="school-page__bottom-part">
        <MainCourseComponent :data="main_course" @claimCreate="claimCreate" />
        <SchoolReviewsComponent :reviews="school.reviews" @reload="load($apolloProvider, $store)" />
        <SchoolAddressComponent />
      </div>
    </div>
  </div>
</template>

<script>
import SCHOOL_PAGE from "@/graphql/pages/SchoolPage.graphql";
import BreadcrumbsComponent from "components/BreadcrumbsComponent.vue";
import AdditionalInfoComponent from "./components/AdditionalInfoComponent.vue";
import SliderComponent from "components/SliderComponent.vue";
import SpeakerComponent from "./components/SpeakerComponent.vue";
import CourseComponent from "./components/CourseComponent.vue";
import MainCourseComponent from "./components/MainCourseComponent.vue";
import SchoolReviewsComponent from "./components/SchoolReviewsComponent.vue";
import SchoolAddressComponent from "./components/SchoolAddressComponent.vue";
import SchoolClaimModal from "components/modals/components/SchoolClaimModal.vue";

async function load(apollo, store) {
  await apollo.defaultClient
    .query({
      query: SCHOOL_PAGE,
    })
    .then(({ data }) => {
      store.state.school_page.school = data.school;
      store.state.school_page.courses = data.courses;
      store.state.all_brands = data.brands || [];
      store.state.popular_brands = data.brands_paginate.data || [];
      store.state.categories = data.header_categories.data || [];
      store.state.pages = data.pages;
      store.state.marketplace = data.marketplace;
    });
}

export default {
  name: "SchoolPage",
  async asyncData({ apollo, store }) {
    await load(apollo, store);
  },
  data() {
    return {
      speakersSliderOptions: {
        slidesPerView: "auto",
        spaceBetween: 20,
        pagination: false,
        clickable: false,
        preloadImages: true,
        watchOverflow: true,
        breakpoints: {
          860: {
            slidesPerView: "auto",
            spaceBetween: 30,
          },
        },
      },
      coursesSliderOptions: {
        slidesPerView: "auto",
        pagination: false,
        centeredSlides: true,
        roundLengths: true,
        slideToClickedSlide: true,
        watchOverflow: true,
        watchSlidesProgress: true,
      },
    };
  },
  computed: {
    school() {
      return this.$store.state.school_page?.school || {};
    },
    courses() {
      return this.$store.state.school_page?.courses && this.$store.state.school_page.courses.length
        ? this.$store.state.school_page.courses.filter((course) => !course.is_main)
        : [];
    },
    main_course() {
      return this.$store.state.school_page?.courses && this.$store.state.school_page.courses.length
        ? this.$store.state.school_page.courses.find((course) => course.is_main)
        : [];
    },
    links() {
      return [{ title: "Школа мам" }];
    },
  },
  methods: {
    claimCreate(data) {
      this.$store.state._modals.push({
        component: SchoolClaimModal,
        options: { data },
      });
    },
    load,
  },
  components: {
    SpeakerComponent,
    CourseComponent,
    MainCourseComponent,
    SchoolReviewsComponent,
    SchoolAddressComponent,
    SliderComponent,
    BreadcrumbsComponent,
    AdditionalInfoComponent,
  },
  metaInfo: {
    title: "Школа мам",
  },
};
</script>

<style lang="stylus">
.school-page {
  width 100%
  display grid
  grid-gap 30px
  padding-top 30px
  padding-bottom 50px
  +below(420px) {
    grid-gap 16px
  }

  &__welcome {
    height: 400px
    background url("/static/images/about_school.jpg")
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    transform: scale(-1, 1);
    display: flex
    align-items: center
    +below(580px) {
      height: 280px
    }

    &--shift {
      margin-bottom: -50px
    }

    .title {
      transform: scale(-1, 1);
      text-align: left
      color: var(--main-color)
      margin: 0
    }

    &-info {
      .title {
        margin-bottom 30px
      }
    }
  }

  &__top-part {
    display flex
    flex-direction column
    gap 30px
  }

  &__bottom-part {
    display flex
    flex-direction column
    gap 50px
  }
}

.school-courses {
  padding: 45px 0
  background: var(--gray_o3)
  +below(560px) {
    padding 20px var(--sides_padding) 45px
  }

  .slider__header {
    margin: 0
  }

  .slider-arrows {
    margin: 0
  }

  .swiper-wrapper {
    align-items: center
  }

  .swiper-slide {
    transform: scale(0.9)
    transition: all 0.2s linear;
    width: auto;
    display: inline-flex;
    justify-content: center;
    align-items: center;
    height: 100%;
    transition: var(--transition);
    padding: 30px 0;

    &.swiper-slide-active {
      transform: scale(1)
    }
  }
}
</style>
